import axiosInstance from "@/composables/axios-instance";

const state = {
  dashboard: {},
};

const getters = {
  getDashboardData(state) {
    return state.dashboard;
  },
};

const mutations = {
  setDashboardData(state, data) {
    state.dashboard = data;
  },
};

const actions = {
  getDashboardDataFromApi({ commit }) {
    return axiosInstance.get("/authenticate/dashboard/").then(response => {
        commit("setDashboardData", response.data);
      }).catch((error) => {
        console.log(error);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
